<template>
    <div class="subscription">
        <h1>pay securely.<br />no commitment.<br />cancel anytime.</h1>
        <form class="subscription__form" autocomplete="off" v-on:submit="updateCard">
            <div class="subscription__card">
                <div class="subscription__card__number">
                    <div class="subscription__input" v-bind:class="{ 'has-error' : cardError.number }">
                        <label for="credit-card-number">Card Number</label>
                        <div class="subscription__card__number__hosted-field" id="card-number"></div>
                        <span class="subscription__help-block" v-if="cardError.number">{{ cardError.number }}</span>
                        <span class="subscription__help-block" v-if="!cardError.number && cardType">{{ cardType }}</span>
                    </div>
                </div>
                <div class="subscription__card__expiry-cvv">
                    <div class="subscription__input" v-bind:class="{ 'has-error' : cardError.expiry }">
                        <label for="expiration">Expiry date</label>
                        <div class="subscription__card__number__hosted-field" id="card-expiry"></div>
                        <span class="subscription__help-block" v-if="cardError.expiry">{{ cardError.expiry }}</span>
                    </div>
                    <div class="subscription__input" v-bind:class="{ 'has-error' : cardError.cvv }">
                        <label for="cvv">CVV</label>
                        <div class="subscription__card__number__hosted-field" id="card-cvv"></div>
                        <span class="subscription__help-block" v-if="cardError.cvv">{{ cardError.cvv }}</span>
                    </div>
                </div>
            </div>

            <button class="subscription__btn" type="submit" v-bind:disabled="actionDisabled">Update card details</button>

            <div class="subscription__braintree-notice">
                <small>Our payment methods are secure and trusted, provided by Braintree.</small>
                <a href="https://www.braintreegateway.com/merchants/dfcxqckjrznvdgpw/verified" target="_blank">
                    <img src="https://s3.amazonaws.com/braintree-badges/braintree-badge-wide-light.png" width="140px" height="22px" border="0"/>
                </a>
            </div>
        </form>
    </div>
</template>

<script>
    import braintree from 'braintree-web';

    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            this.braintreeSetup();
        },
        data: function () {
            return {
                actionDisabled: true,
                cardError: {
                    number: null,
                    expiry: null,
                    cvv: null
                },
                cardType: null,
                cardValid: {
                    number: false,
                    expiry: false,
                    cvv: false
                },
                hostedFields: null
            }
        },
        methods: {
            braintreeSetup: function () {
                braintree.client.create({
                    authorization: this.braintreeAuthorization
                }, function(err, clientInstance) {
                    if (err) {
                        console.error(err);
                        return;
                    }

                    braintree.hostedFields.create({
                        client: clientInstance,
                        styles: {
                            'input': {
                                'color': '#ffffff',
                                'font-size': '11px'
                            }
                        },
                        fields: {
                            cvv: {
                                placeholder: '123',
                                selector: '#card-cvv'
                            },
                            expirationDate: {
                                placeholder: 'MM/YYYY',
                                selector: '#card-expiry'
                            },
                            number: {
                                placeholder: 'XXXX XXXX XXXX XXXX',
                                selector: '#card-number'
                            }
                        }
                    }, function(err, hostedFieldsInstance) {
                        if (err) {
                            console.error(err);
                            return;
                        }

                        hostedFieldsInstance.on('validityChange', function(event) {
                            let field = event.fields[event.emittedBy];

                            if (field.isValid) {
                                if (event.emittedBy === 'cvv') {
                                    this.cardError.cvv = null;
                                    this.cardValid.cvv = true;
                                } else if (event.emittedBy === 'expirationDate') {
                                    this.cardError.expiry = null;
                                    this.cardValid.expiry = true;
                                } else if (event.emittedBy === 'number') {
                                    this.cardError.number = null;
                                    this.cardValid.number = true;
                                }
                            } else if (field.isPotentiallyValid) {
                                if (event.emittedBy === 'cvv') {
                                    this.cardError.cvv = null;
                                    this.cardValid.cvv = false;
                                } else if (event.emittedBy === 'expirationDate') {
                                    this.cardError.expiry = null;
                                    this.cardValid.expiry = false;
                                } else if (event.emittedBy === 'number') {
                                    this.cardError.number = null;
                                    this.cardValid.number = false;
                                }
                            } else {
                                if (event.emittedBy === 'cvv') {
                                    this.cardError.cvv = 'Invalid CVV';
                                    this.cardValid.cvv = false;
                                } else if (event.emittedBy === 'expirationDate') {
                                    this.cardError.expiry = 'Invalid expiry date';
                                    this.cardValid.expiry = false;
                                } else if (event.emittedBy === 'number') {
                                    this.cardError.number = 'Invalid credit card number';
                                    this.cardValid.number = false;
                                }
                            }

                            let formValid = true;
                            for (let key in this.cardValid) {
                                if (this.cardValid.hasOwnProperty(key)) {
                                    if (!this.cardValid[key]) {
                                        formValid = false;
                                    }
                                }
                            }

                            this.actionDisabled = !formValid;
                        }.bind(this));

                        hostedFieldsInstance.on('cardTypeChange', function(event) {
                            this.cardType = event.cards.length === 1 ? event.cards[0].niceType : null;
                        }.bind(this));

                        this.hostedFields = hostedFieldsInstance;
                    }.bind(this));
                }.bind(this));
            },
            updateCard: function (e) {
                e.preventDefault()

                this.hostedFields.tokenize(function (err, payload) {
                    if (err) {
                        console.error(err);

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'error',
                                'error': err
                            });
                        }

                        return;
                    }

                    eventBus.$emit('show-loader');

                    this.$http.post('/api/subscription/update-card', {
                        nonce: payload.nonce,
                        plan: 'update-card',
                        user: JSON.parse(user)
                    }).then(function() {
                        eventBus.$emit('hide-loader');

                        window.location.href= '/subscription';
                    }, function() {
                        console.error('ERROR: there was an error creating subscription.');

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'error',
                                'error': 'There was an error processing credit card'
                            });
                        }

                        this.cardError.number = 'There was an error processing credit card';

                        eventBus.$emit('hide-loader');
                    });
                }.bind(this));
            }
        },
        props: {
            braintreeAuthorization: {
                required: true,
                type: String
            }
        }
    }
</script>
